import { useRef, useState } from "react";
import { SlTab, SlTabGroup, SlTabPanel } from "@shoelace-style/shoelace/dist/react";
import SheetOnePreview from "./Sheet1/SheetOnePreview";
import SheetFourPreview from "./Sheet4/SheetFourPreview";
import SheetTwoPreview from "./Sheet2/SheetTwoPreview";
import SheetThreePreview from "./Sheet3/SheetThreePreview";
import NewBusinessDevelopment from "./NBD/NewBusinessDevelopment"; 
import SheetFivePreview from "./Sheet5/SheetFivePreview";

const PhionexReports = () => {
  const tabGroupRef = useRef(null);
  const [activeTab, setActiveTab] = useState("sheet-1");

  return (
    <div className="p-4 font-sans">
      <SlTabGroup
        ref={tabGroupRef}
        onSlTabShow={(e) => {
          setActiveTab(e.detail.name);
        }}
      >
        <SlTab slot="nav" panel="sheet-1">Sheet 1</SlTab>
        <SlTab slot="nav" panel="sheet-2">Sheet 2</SlTab>
        <SlTab slot="nav" panel="sheet-3">Sheet 3</SlTab>
        <SlTab slot="nav" panel="sheet-4">Sheet 4</SlTab>
        <SlTab slot="nav" panel="sheet-5">Sheet 5</SlTab>
        <SlTab slot="nav" panel="nmd">New Business Development</SlTab>
        <SlTabPanel name="sheet-1">
          {activeTab === "sheet-1" && <SheetOnePreview key="sheet-1" />}
        </SlTabPanel>
        <SlTabPanel name="sheet-2">
          {activeTab === "sheet-2" && <SheetTwoPreview key="sheet-2" />}
        </SlTabPanel>
        <SlTabPanel name="sheet-3">
          {activeTab === "sheet-3" && <SheetThreePreview key="sheet-3" />}
        </SlTabPanel>
        <SlTabPanel name="sheet-4">
          {activeTab === "sheet-4" && <SheetFourPreview key="sheet-4" />}
        </SlTabPanel>
        <SlTabPanel name="sheet-5">
          {activeTab === "sheet-5" && <SheetFivePreview key="sheet-5" />}
        </SlTabPanel>
        <SlTabPanel name="nmd">
          {activeTab === "nmd" && <NewBusinessDevelopment key="nmd" />}
        </SlTabPanel>
      </SlTabGroup>
    </div>
  );
};

export default PhionexReports;
